/**
 * useFilterOptions Hook
 *
 * React Query hook for fetching filter options from the API.
 * Uses filterService for the actual API call.
 */

import { useQuery } from '@tanstack/react-query';
import { getFilterOptions, type FilterOptions } from '../../../../../services/filterService';

/**
 * Query key for filter options.
 */
export const filterOptionsQueryKey = ['filter-options'] as const;

/**
 * Hook to fetch filter options for the Global Filter Strip.
 *
 * Returns organization-scoped options for:
 * - Product categories
 * - Journey stages
 * - Channels
 *
 * Options are cached for 5 minutes as they rarely change.
 */
export function useFilterOptions() {
  return useQuery<FilterOptions>({
    queryKey: filterOptionsQueryKey,
    queryFn: getFilterOptions,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    // Return empty options on error to allow UI to render
    placeholderData: {
      productCategories: [],
      journeyStages: [],
      channels: [],
    },
  });
}
